import React from 'react';
import PropTypes from 'prop-types';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleStep = ({
    title,
    stepItemsCollection,
    parent
}) => {

    const items = stepItemsCollection.items;
    const words = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'];

    return (
        <div className={`bg-white relative ${parent === 'Home' ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'}`}>
            <div className='layout-container'>

                <div className='bg-white -mx-10 sm:-mx-35 md:mx-0  md:px-10'>
                    <div
                        className='bg-sand rounded-button py-30 md:pb-50 md:pt-42 sm:px-35 md:px-0'>
                        {title &&
                            <div className='pb-20 sm:pb-10 md:pb-35 px-20 sm:px-5 md:px-50'>
                                <h2 className='type-style-3'>{title}</h2>
                            </div>
                        }
                        <div className='w-full grid sm:grid-cols-2 gap-y-20 md:gap-30 grid-cols-1 md:px-50'>

                            {/* Step Item */}
                            {items.map((item, idx) => (
                                <div
                                    className='w-full flex px-20 sm:px-5 md:px-0'
                                    key={idx}>

                                    {/* Big number */}
                                    <div className='pt-[32px] md:pt-0 sm:w-1/6 border-b border-dark-grey md:leading-[80%] type-style-4 md:type-style-6'>
                                        {idx + 1}
                                    </div>

                                    {/* Text */}
                                    <div className='w-full md:w-5/6 pb-20 pl-30 sm:pl-0 md:pl-10 md:pb-40 border-b border-dark-grey flex flex-wrap'>
                                        <div className='flex flex-col gap-y-15'>

                                            <p className='text-orange type-style-7'>Step {words[idx]}</p>
                                            <p className='type-style-4'>{item.title}</p>
                                            <p className='w-10/12 type-style-5 text-light-grey'>{item.body}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleStep.propTypes = {
    stepItemsCollection: PropTypes.object,
    title: PropTypes.string,
    parent: PropTypes.string,
};

export default ModuleStep;
